export const modalZIndex = 2001;

// Demotes a modal below an external overlay outside this app's modalZIndex convention
// (e.g. a microfrontend like Soft Pull with its own independent stacking context).
export const belowExternalOverlayZIndex = 1;
